<template>
    
    <div 
        class="gap-6 grid grid-cols-2"
        :class="{
            'px-8 pt-6 pb-8': !fromDialog,
            'px-6 pt-6': fromDialog,
        }"
    >

        <div class="bg-gray-tier-5 rounded-lg grow flex flex-col p-7" :class="{ 'text-sm !p-6': fromDialog }">
            <div class="mb-6">
                <span class="type-secondary text-base">{{ $t("Quote Total") }}</span>
                <h5 class="type-primary text-2xl font-medium">{{ showMeTheMoney(quote.total) }}</h5>
            </div>
            <div v-if="isEmployee && quote.gross_profit" class="flex items-center justify-between border-b border-t border-keyline-tertiary py-1.5">
                <span class="type-secondary">{{ $t("GP") }}</span>
                <span class="type-primary">{{ quote.gross_profit }}%</span>
            </div>
            <div class="flex items-center justify-between border-b border-keyline-tertiary py-1.5">
                <span class="type-secondary">{{ $t("Freight") }}</span>
                <span class="type-primary tabular-nums">TBD</span>
            </div>
            <div class="flex items-center justify-between border-b border-keyline-tertiary py-1.5">
                <span class="type-secondary">{{ $t("Tax") }}</span>
                <span class="type-primary tabular-nums">TBD</span>
            </div>
            <div class="flex items-center justify-between border-b border-keyline-tertiary py-1.5">
                <span class="type-secondary">{{ $t("Sub Total") }}</span>
                <span class="type-primary tabular-nums">{{ showMeTheMoney(quote.subtotal) }}</span>
            </div>
            <div class="flex items-center justify-between border-b border-keyline-tertiary py-1.5">
                <span class="type-secondary">{{ $t("Total") }}</span>
                <span class="type-primary font-bold tabular-nums">{{ showMeTheMoney(quote.total) }}</span>
            </div>
        </div>

        <div class="bg-gray-tier-5 rounded-lg flex flex-col leading-relaxed" :class="{ 'text-sm': fromDialog }">
            <div class="pb-2" :class="fromDialog ? 'p-6' : 'p-7'">
                <h5 class="type-primary block text-base">
                    <b>{{ quote.customer?.name }}</b>
                </h5>
                <ul>
                    <li>
                        <span class="type-secondary mr-2">{{$t("Customer ID") }}</span>
                        <span class="type-primary font-medium">{{quote.customer?.id}}</span>
                    </li>
                    <li v-if="isEmployee">
                        <span class="type-secondary mr-2">{{$t("Customer Group") }}</span>
                        <span class="type-primary font-medium">{{quote.customer?.group}}</span>
                    </li>
                    <li>
                        <span class="type-secondary mr-2">{{$t("Location") }}</span>
                        <span class="type-primary font-medium">{{quote.customer?.address?.city}}, {{quote.customer?.address?.state}}</span>
                    </li>
                    <li>
                        <span class="type-secondary mr-2">{{$t("Free Freight") }}</span>
                        <span class="type-primary font-medium">{{showMeTheMoney(quote.customer?.free_shipping_at)}}</span>
                    </li>
                    <li v-if="quote.customer?.terms_code">
                        <span class="type-secondary mr-2">{{$t("Terms") }}</span>
                        <span class="type-primary font-medium">{{quote.customer?.terms_code }}</span>
                    </li>
                    <li>
                        <span class="type-secondary mr-2">{{$t("Order By") }}</span>
                        <span class="type-primary font-medium">{{ quote.order_by ?? "–" }}</span>
                    </li>
                </ul>
            </div>
            <div class="grow pl-2 pr-4 pb-4">
                <apex-chart
                    height="90%"
                    :options="chartOptions"
                    :series="series"
                />
            </div>
        </div>
    </div>
    
</template>
<script setup>
import { useUser, useHelpers, useApexCharts } from "@/Composables";
import { computed } from "vue";
const { isEmployee } = useUser();
const { showMeTheMoney } = useHelpers();
const { chart_options: chartOptions } = useApexCharts('chart_customer_sales');
const series = computed(() => [
    {
        name: 'Sales',
        data: props.salesData?.sales_graph ? [...props.salesData.sales_graph].reverse() : [],
    },
]);

const props = defineProps({
    quote: {
        type: Object,
        required: true,
    },
    salesData: {
        type: Object,
        required: false,
    },
    fromDialog: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>
